var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAiIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 18,
  fill: "url(#ai-icon_svg__a)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m17.9 14.801-9.167 9.173a2.39 2.39 0 1 0 3.38 3.379l9.165-9.172L17.9 14.8Zm5.733 5.835-.107-.008a.79.79 0 0 0-.782.682l-.008.108v.79h-.79a.79.79 0 0 0-.781.682l-.008.107c0 .4.297.73.683.782l.107.007h.79v.79c0 .4.296.73.682.782l.107.008a.79.79 0 0 0 .782-.683l.008-.107v-.79h.789a.79.79 0 0 0 .782-.682l.008-.107a.79.79 0 0 0-.683-.782l-.107-.008h-.79v-.79a.79.79 0 0 0-.682-.781ZM19.91 12.8l-.143.133-.75.75 3.38 3.38.749-.752a2.37 2.37 0 0 0-.001-3.35l-.165-.153a2.369 2.369 0 0 0-3.07-.008Zm-6.803-2.693L13 10.101a.79.79 0 0 0-.782.682l-.008.108v.79h-.79a.79.79 0 0 0-.782.681l-.007.108c0 .4.297.73.682.782l.108.007h.79v.79c0 .4.296.73.681.782l.108.007a.79.79 0 0 0 .782-.682l.007-.107v-.79h.79a.79.79 0 0 0 .782-.682l.007-.107a.79.79 0 0 0-.682-.783l-.107-.007h-.79v-.79a.79.79 0 0 0-.682-.782ZM25.74 8.003l-.108-.007a.79.79 0 0 0-.782.682l-.007.107v.79h-.79a.79.79 0 0 0-.782.682l-.007.107c0 .4.297.73.682.782l.107.008h.79v.79c0 .4.297.729.682.781l.107.008a.79.79 0 0 0 .783-.682l.007-.108v-.79h.79a.79.79 0 0 0 .782-.681l.007-.108a.79.79 0 0 0-.682-.782l-.108-.007h-.79v-.79a.79.79 0 0 0-.681-.782Z",
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "ai-icon_svg__a",
  x1: 2.864,
  y1: 36,
  x2: 31.909,
  y2: 6.545,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0089FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#35D2F4"
})))));
export { SvgAiIcon as ReactComponent };
export default __webpack_public_path__ + "images/ai-icon.svg";